import { CopyButton } from '@/components/CopyButton'

interface SecretValueProps {
  value: string
  label: string
}

/** A secret on screen: monospace, selectable in one click, with a copy button. */
export function SecretValue({ value, label }: SecretValueProps) {
  return (
    <div className="flex items-center gap-1 rounded-md border border-border bg-subtle py-1 pr-1 pl-3">
      <code className="min-w-0 flex-1 truncate font-mono text-caption select-all">{value}</code>
      <CopyButton value={value} label={label} />
    </div>
  )
}
